import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, Box, Icon } from '@chakra-ui/react'

interface AddressChangeAlertIProps {
  isEmergencyCallConfigured: boolean
  isEmergencyCallEnabled: boolean
  hasAddressChanged: boolean
}

export const AddressChangeAlert = ({
  isEmergencyCallConfigured,
  isEmergencyCallEnabled,
  hasAddressChanged,
}: AddressChangeAlertIProps) => {
  if (
    !isEmergencyCallConfigured ||
    !isEmergencyCallEnabled ||
    !hasAddressChanged
  ) {
    return null
  }

  return (
    <Box px='6'>
      <Alert
        bg='#DBE9FE'
        borderRadius='10px'
        color='#1D40B0'
        mb={4}
        status='info'
      >
        <Icon
          as={HiOutlineInformationCircle}
          boxSize='20px'
          color='#1D40B0'
          mr='10px'
        />
        <Box fontSize='13px' fontWeight={400}>
          The emergency number address must also be updated outside HiveWatch to
          reflect this change.
        </Box>
      </Alert>
    </Box>
  )
}
